/* ==========================
   TRENDING SEASON — EDITORIAL
   JS — Full File
========================== */

// ─── Shopify Theme Editor Events ───────────────────────────────────────────

function hideProductModal() {
  const productModal = document.querySelectorAll('product-modal[open]');
  productModal && productModal.forEach((modal) => modal.hide());
}

document.addEventListener('shopify:block:select', function (event) {
  hideProductModal();
  const blockSelectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockSelectedIsSlide) return;
  const parentSlideshowComponent = event.target.closest('slideshow-component');
  parentSlideshowComponent.pause();
  setTimeout(function () {
    parentSlideshowComponent.slider.scrollTo({ left: event.target.offsetLeft });
  }, 200);
});

document.addEventListener('shopify:block:deselect', function (event) {
  const blockDeselectedIsSlide = event.target.classList.contains('slideshow__slide');
  if (!blockDeselectedIsSlide) return;
  const parentSlideshowComponent = event.target.closest('slideshow-component');
  if (parentSlideshowComponent.autoplayButtonIsSetToPlay) parentSlideshowComponent.play();
});

document.addEventListener('shopify:section:load', () => {
  hideProductModal();
  const zoomOnHoverScript = document.querySelector('[id^=EnableZoomOnHover]');
  if (!zoomOnHoverScript) return;
  const newScriptTag = document.createElement('script');
  newScriptTag.src = zoomOnHoverScript.src;
  zoomOnHoverScript.parentNode.replaceChild(newScriptTag, zoomOnHoverScript);
});

document.addEventListener('shopify:section:unload', (event) => {
  document.querySelectorAll(`[data-section="${event.detail.sectionId}"]`).forEach((element) => {
    element.remove();
    document.body.classList.remove('overflow-hidden');
  });
});

document.addEventListener('shopify:section:reorder', () => hideProductModal());
document.addEventListener('shopify:section:select', () => hideProductModal());
document.addEventListener('shopify:section:deselect', () => hideProductModal());
document.addEventListener('shopify:inspector:activate', () => hideProductModal());
document.addEventListener('shopify:inspector:deactivate', () => hideProductModal());


// ─── Toast Helper ──────────────────────────────────────────────────────────

function tsShowToast(message, duration) {
  duration = duration || 2500;
  var toast = document.getElementById('ts-toast');
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add('ts-toast-show');
  setTimeout(function () {
    toast.classList.remove('ts-toast-show');
  }, duration);
}


// ─── Cart Count Refresh ────────────────────────────────────────────────────

function tsRefreshCartCount() {
  // Method 1: Dawn theme section rendering
  fetch('/?sections=cart-icon-bubble')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data && data['cart-icon-bubble']) {
        document.querySelectorAll('#cart-icon-bubble').forEach(function (el) {
          el.innerHTML = data['cart-icon-bubble'];
        });
      }
    })
    .catch(function () {});

  // Method 2: Dispatch cart:refresh event (works with many themes)
  document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

  // Method 3: Dispatch custom event for themes that listen to it
  document.dispatchEvent(new CustomEvent('theme:cart:add', { bubbles: true }));
}


// ─── Quick Add To Cart ─────────────────────────────────────────────────────

document.addEventListener('click', function (e) {
  var btn = e.target.closest('.ts-quick-add');
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  var variantId = btn.getAttribute('data-variant-id');
  if (!variantId) return;

  // Prevent double-click
  if (btn.disabled) return;

  // Set loading state
  btn.disabled = true;
  btn.classList.add('ts-adding');
  btn.textContent = '...';

  // Add to cart via Shopify AJAX API
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      id: parseInt(variantId, 10),
      quantity: 1
    })
  })
  .then(function (response) {
    if (!response.ok) {
      return response.json().then(function (err) { throw err; });
    }
    return response.json();
  })
  .then(function (item) {
    // ✅ Success state
    btn.classList.remove('ts-adding');
    btn.classList.add('ts-added');
    btn.textContent = '✓';

    // Show toast
    tsShowToast((item.title || 'Product') + ' added to cart!');

    // Refresh cart count / open cart drawer
    tsRefreshCartCount();

    // Try to open cart drawer if theme supports it
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open(btn);
    }

    // Reset button after 2 seconds
    setTimeout(function () {
      btn.classList.remove('ts-added');
      btn.textContent = '＋';
      btn.disabled = false;
    }, 2000);
  })
  .catch(function (err) {
    // ❌ Error state
    btn.classList.remove('ts-adding');
    btn.classList.add('ts-error');
    btn.textContent = '✕';

    var message = (err && err.description) ? err.description : 'Could not add to cart';
    tsShowToast(message, 3000);

    setTimeout(function () {
      btn.classList.remove('ts-error');
      btn.textContent = '＋';
      btn.disabled = false;
    }, 2000);
  });
});
